import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import YouTube from "react-youtube";
import PrimaryButton from "./buttons/primaryButton";
import CloseIcon from "@mui/icons-material/Close";

function YouTubePlayer(props) {
  const options = {
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      enablejsapi: 1,
      origin: "http://localhost:3000/",
      color: "white",
      autoplay: 1,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {props.title}{" "}
        <IconButton
          aria-label="close"
          onClick={props.onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <YouTube videoId={props.videoId} opts={options} />
      </DialogContent>

      <DialogActions>
        <PrimaryButton onClick={props.onClose}>Close</PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

export default YouTubePlayer;
